export default "__VITE_ASSET__450f3fa1__"